<div class="quote-banner" *ngIf="visible" (click)="openModal()" role="button" tabindex="0" (keydown.enter)="openModal()" aria-label="Get a quote">
  <span class="quote-banner__text">
    Ready to get started? <a class="quote-banner__link">Get a quote <span aria-hidden="true">&rarr;</span></a>
  </span>
  <button class="quote-banner__close" (click)="dismiss($event)" aria-label="Dismiss banner">
    <i class="fas fa-times"></i>
  </button>
</div>

<!-- Quote iframe modal -->
<div class="quote-banner-modal-overlay" *ngIf="modalOpen" (click)="closeModal()">
  <div class="quote-banner-modal" (click)="$event.stopPropagation()">
    <button class="quote-banner-modal__close" (click)="closeModal()" aria-label="Close modal">
      <i class="fas fa-times"></i>
    </button>
    <div class="quote-banner-modal__loading" *ngIf="iframeLoading">
      <i class="fas fa-spinner fa-spin fa-2x"></i>
      <span>Loading form...</span>
    </div>
    <iframe
      [src]="iframeUrl"
      width="100%"
      height="1200"
      style="border:0;"
      [style.opacity]="iframeLoading ? 0 : 1"
      (load)="iframeLoading = false">
    </iframe>
  </div>
</div>
